// ----------------------------------------------------------------------------
// Component: Product Recommendations
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import 'snippets/card/card';
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';

// Styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_product-recommendations.scss';


// -------------------------------------
// Dynamic Recommendations
// -------------------------------------
function handleSlides(swiperEl) {
  swiperEl.slides.forEach(function(slide, index) {
      let slideLink = slide.querySelector('a');
      slideLink.addEventListener('focus', function(e) {
          swiperEl.slideTo(index);
      })
  });
}

$(document).ready(function(){
  $(".carousel--product-recommendations").each(function(index, element){
    var $this = $(this);

    // Generate unique class for each feature collection slider
    $this.addClass("product-recommendations-instance-" + index);

    // Initialize feature collection slider based on the unique classes generated above.
    var swiper = new Swiper(".product-recommendations-instance-" + index, {
        // Optional parameters
        modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
        slidesPerView: 1.5,
        spaceBetween: 5,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

        breakpoints: {
          // when window width is >= 680px
          680: {
            slidesPerView: 4,
          }
        },
    });

    swiper.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiper.slideTo(index);
        })
    });
  });

  var loadProductRecommendationsIntoSection = function() {
       // Look for an element with class 'product-recommendations'
       var productRecommendationsSection = document.querySelector(".product-recommendations");
       if (productRecommendationsSection === null) { return; }

       // Read product id from data attribute
       var productId = productRecommendationsSection.dataset.productId;

       // Read limit from data attribute
       var limit = productRecommendationsSection.dataset.limit;
      var productType = productRecommendationsSection.dataset.productType;

       // Build request URL
       var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;

       // Create request and submit it using Ajax
       var request = new XMLHttpRequest();
       request.open("GET", requestUrl);
       request.onload = function() {
         if (request.status >= 200 && request.status < 300) {
           var container = document.createElement("div");
           container.innerHTML = request.response;
           productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
         }
       };
       request.send();
  };

   // If your section has theme settings, the theme editor
   // reloads the section as you edit those settings. When that happens, the
   // recommendations need to be fetched again.
   // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
   // document.addEventListener("shopify:section:load", function(event) {
   //   if (event.detail.sectionId === "product-recommendations") {
   //     loadProductRecommendationsIntoSection();
   //   }
   // });

   // Fetching the recommendations on page load
  //  loadProductRecommendationsIntoSection();
});
